var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddonCol = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  fillRule: "evenodd",
  d: "M17.314 5.259 13.49 7.382v2.174a.637.637 0 0 1-1.274 0V8.09L9.67 9.506V18l7.317-4.065a.64.64 0 0 0 .328-.557zm-16.564 0v8.12a.64.64 0 0 0 .328.556L8.395 18V9.506zm4.575 8.487 1.274.708a.638.638 0 0 0 .619-1.114l-1.275-.707a.637.637 0 0 0-.618 1.113m-3.938-9.59 2.553-1.42 7.645 4.248-2.553 1.418zm3.865-2.148 7.645 4.247 3.78-2.1L9.34.08a.64.64 0 0 0-.618 0z",
  clipRule: "evenodd"
})));
export { SvgAddonCol as ReactComponent };
export default __webpack_public_path__ + "static/media/addon-col.5c90f4f0.svg";